module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_7016.b08d59c1.png";